module.exports = __webpack_public_path__ + "static/media/garage-vehicle-placeholder.9504f69a.svg";